module.exports = __webpack_public_path__ + "static/media/icono firmaconvenio.dc57a503.svg";